// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G_s6D","col":"styles_col__K8fMm"};